<template>
    <div>
        <div class="measure-label primary--text">
            {{ label }}
        </div>
        <div class="measure-text ro-background pa-2">
            {{ text }}
        </div>
    </div>
</template>

<script>
export default {
    name: "PAuditMeasure",

    props: {
        label: {

        },

        text: {

        }
    }
}
</script>

<style scoped>

.measure-label {
    font-size: 13px;
}

.measure-text {
    font-size: 16px;
    height: 100px;
}


</style>